import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { getAccessTokenFromRefresh } from 'src/features/auth/store/authThunks';
import { AppDispatch } from 'src/store/index';

const AutoSignInPage = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const token = searchParams.get('token');
		if (token) {
			dispatch(
				getAccessTokenFromRefresh({
					refreshToken: token,
					onSuccess: () => {
						navigate('/dashboard');
					},
					onError: () => {
						navigate('/signin');
					},
				}),
			);
		}
	}, [searchParams]);

	return null;
};

export default AutoSignInPage;
